import React, { useReducer, useCallback } from "react";
import AddCreate from "../../components/AddCreate/AddCreate";
import UseWritePost from "../../hooks/UseWritePost";
import { AddInsertreducer } from "../../interface/ActionReducer";
import { AddState } from "../../interface/initialState";
function Newadd() {
  const [state, dispatch] = useReducer(AddInsertreducer, AddState);
  const [WritePost] = UseWritePost("광고가 등록되었습니다");
  const UpadteInfo = useCallback(
    (type: string, payload: string | number) => {
      dispatch({
        type,
        payload,
        index: undefined,
      });
    },
    [dispatch]
  );
  const NewAdd = useCallback(() => {
    const {
      ctts_tit,
      btn_label,
      ctts_ctts,
      bg_color,
      ctts_link,
      ad_thumbnail,
      ctts_ctg_cd,
    } = state;
    if (
      ctts_tit &&
      btn_label &&
      ctts_ctts &&
      bg_color &&
      ctts_link &&
      ad_thumbnail
    ) {
      WritePost(
        {
          bbs_id: "5",
          ctts_tit,
          ad_thumbnail,
          btn_label,
          ctts_ctg_cd: "normal",
          ctts_ctts,
          bg_color,
          ctts_link,
        },
        true
      );
    }
  }, [state, WritePost]);

  return (
    <AddCreate
      data={state}
      UpdateInfo={UpadteInfo}
      WritePost={NewAdd}
      addType="new"
    />
  );
}

export default Newadd;
